import React, { useEffect,useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Footer from "../../redesign/components/Footer";
import ManageServicesTabContent from "./ManageServicesTabContent";
import ManageProfileTabContent from "./ManageProfileTabContent";
// import "./ServiceProviderDashboard.css";
import Navbar from "../../redesign/components/Navbar";
import styles from "./ServiceProviderDashboard.module.css";
import { useDispatch, useSelector } from "react-redux";

import {
  getServiceProviderBusinessDetails,
  getServiceProviderProfile,
} from "../../Apiservices/Auth/servers/profileServer";
import {
  setBusinessData,
  setProfileData,
} from "../../store/providerProfileSlice";
import ManageOrdersTabContent from "./ManageOrdersTabContent";

const ServiceProviderDashboard = () => {
  const dispatch = useDispatch();
  const [providerTypes,setproviderTypes]= useState()
  useEffect(() => {
    console.log("Use effect iscalled");
    const fetchDataIfNeeded = async () => {
      try {
        console.log("got here")
        const profile = await getServiceProviderProfile();
        setproviderTypes(profile.providerTypes[0]?.type);
        console.log("providerTypes", profile.providerTypes[0]?.type);
        dispatch(setProfileData(profile));
        
        
      } catch (err) {
        console.error("Error setting profile data", err);
      }

      try {
        const business = await getServiceProviderBusinessDetails();
        dispatch(setBusinessData(business));
      } catch (err) {
        console.error("Error setting business data", err);
      }
    };

    fetchDataIfNeeded();
  }, [dispatch]);
const [activeServiceType, setActiveServiceType] = useState(null);

useEffect(() => {
  console.log("activeServiceType changed =>", activeServiceType);
}, [activeServiceType]);

console.log("activeServiceType",activeServiceType)
  return (
    <div className={styles.dashboardWrapper}>
      <Navbar />
      <main className={`${styles.mainContent} ${
    activeServiceType === "Priest" ? styles.rentalsActive : ""
  }`}>
        <div className={styles.thCustomTabWrapper}>
          <TabView>
            <TabPanel
  header={
    providerTypes?.toLowerCase() === "catering"
      ? "Manage Menu"
      : providerTypes?.toLowerCase() === "priest"
      ? "Manage Priest"
      : providerTypes?.toLowerCase() === "helper"
      ? "Manage Helper"
      : "Manage Services"
  }>
              <ManageServicesTabContent onActiveTypeChange={setActiveServiceType}  />
            </TabPanel>

            <TabPanel header="Manage Orders">
              <ManageOrdersTabContent onActiveTypeChange={setActiveServiceType}  />
              {/* <div sx={{ p: 2 }}>Manage Orders</div> */}
            </TabPanel>

            <TabPanel header="My Account">
              <ManageProfileTabContent />
            </TabPanel>
          </TabView>
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
};

export default ServiceProviderDashboard;
